import {Injectable} from '@angular/core';
import {ApplicationSettingsHelper} from '~/app/shared/helpers/application-settings-helper';
import {environment} from '~/environments/environment';


@Injectable({
    providedIn: 'root'
})
export class ConfigurationService {
    get BASEURL_OLI(): string {
        return this._BASEURL_OLI;
    }

    set BASEURL_OLI(value: string) {
        this._BASEURL_OLI = value;
    }
    get RESTURL_OLI(): string {
        return this._RESTURL_OLI;
    }

    set RESTURL_OLI(value: string) {
        this._RESTURL_OLI = value;
    }

    get SUPPORTRESTURL(): string {
        return this._SUPPORTRESTURL;
    }

    set SUPPORTRESTURL(value: string) {
        this._SUPPORTRESTURL = value;
    }
    readonly RESTURL_CONNECT_SUPPORT = environment.supportServicePrefix;

    get RESTURL(): string {
        return this._RESTURL;
    }

    set RESTURL(value: string) {
        this._RESTURL = value;
    }

    get BASEURL(): string {
        return this._BASEURL + '/sourcelink/';
    }

    set BASEURL(url) {
        this._BASEURL = url;
    }

    _BASEURL = '';
    private _BASEURL_OLI = '';
    readonly RESTPATH = '/fs-sourcelink-ws/rest/v1';
    readonly RESTPATH_OLI = '/fs-online-voicing-ws/rest/v1';
    readonly SUPPORTRESTPATH = '/fs-connect-support-ws/rest/v1'
    private _RESTURL: string;
    private _RESTURL_OLI: string;
    private _SUPPORTRESTURL: string;
    orderStatus: string;

    constructor(private _applicationSettingsHelper: ApplicationSettingsHelper,
    ) {
        this._applicationSettingsHelper.setApplicationMode(environment.production === true ? 'true' : 'false');
    }

    getOrderStatus(): string {
        return this.orderStatus;
    }

    setOrderStatus(value: string) {
        this.orderStatus = value;
    }

    setApiModeMobile() {
        if (this._applicationSettingsHelper.getApplicationMode() === 'true') {
            this.BASEURL = 'https://fsconnect.mclaneco.com';
            this.BASEURL_OLI = 'https://fsconnect.mclaneco.com';
            this.RESTURL = this._BASEURL + this.RESTPATH;
            this.RESTURL_OLI = this._BASEURL_OLI + this.RESTPATH_OLI;
            this.SUPPORTRESTURL = this._BASEURL + this.SUPPORTRESTPATH
            console.log('Production API');
        } else if (this._applicationSettingsHelper.getApplicationMode() === 'false') {
            this.BASEURL = 'https://fsconnect-test.mclaneco.com';
            this.BASEURL_OLI = 'https://fsconnect-test.mclaneco.com';
            this.RESTURL = this._BASEURL + this.RESTPATH;
            this.RESTURL_OLI = this._BASEURL_OLI + this.RESTPATH_OLI;
            this.SUPPORTRESTURL = this._BASEURL + this.SUPPORTRESTPATH
            console.log('UAT API');
        }
    }

    setApiModeWeb() {
        this.RESTURL = environment.servicePrefix;
        this.RESTURL_OLI = environment.servicePrefix_OLI;
    }
}
